import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventNormalizers from '../normalizers/eventNormalizers';

export class AssignEventRequest extends BaseApiPatchRequest<
  {},
  EntityNormalizers.NormalizedSingleEntity<EventNormalizers.NormalizedEvents>
> {
  constructor(eventId: string, userId: string, component: React.Component, dispatch: Dispatch) {
    super({ assigneeId: userId }, component, dispatch);
    this.path = `/events/${eventId}/`;
    this.normalizeMethod = EventNormalizers.normalizeEvent;
  }
}
